import React from "react";
import Section from "../components/Section";

function PushNotifications() {
  return (
    <Section id="push-notifications" icon="🔔" title="Push Notifications">
      <p>
        With your permission, the App may send push notifications to your device. These notifications
        may include:
      </p>
      <ul>
        <li>Updates related to food reviews you have submitted</li>
        <li>New feature announcements</li>
        <li>Relevant recommendations based on your App activity</li>
      </ul>
      <p>
        You can opt out of push notifications at any time by going to your device's{" "}
        <strong>Settings → Notifications → Food-Is</strong> and disabling notifications.
        Opting out does not affect your ability to use any other features of the App.
      </p>
    </Section>
  );
}

export default PushNotifications;
